import { render, staticRenderFns } from "./DefaultLocationsIndex.vue?vue&type=template&id=9b4ab5c0&"
import script from "./DefaultLocationsIndex.vue?vue&type=script&lang=js&"
export * from "./DefaultLocationsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLocationsIndex.vue?vue&type=style&index=0&id=9b4ab5c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports